<template>
  <div>
    <QHloading v-if="QHloading"></QHloading>
    <div class="QHpostionDaohang">
      <div class="box flex-center on"><span>{{$getCityFuqin('name')}}清运量热力图</span></div>
    </div>
    <div class="QHzuobiaoMapPage" id="map"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      QHloading:true,
      map: null,
      maskLayer: null,
    };
  },

  mounted() {
    this.getData();
  },

  methods: {
    //获取地图标记数据
    getData() {
      var that = this;
      var https = {
        type: "isApi",
        isLoading: "isLoadingPop",
        api: this.$api.getQingyunReli,
      };
      that.$httpsApi(https, function (res) {
        //整合热力数据
        var list = that.getFmtData(res.data);

        //执行地图初始化
        that.mapInit(list);
        
      });
    },

    //格式化成地图需要的格式数据(热力)
    getFmtData(data) {
      var that = this;
      var list = [];
      for (var i = 0; i < data.length; i++) {
        var value = data[i];
        var coordinate = that.$commaToarr(value["coordinates"]);
        var obj = {};
        if (!that.$isblank(coordinate) && coordinate.length == 2) {
          obj["lat"] = parseFloat(coordinate[0]);
          obj["lng"] = parseFloat(coordinate[1]);
          obj["count"] = value["count"];
          list.push(obj);
        }
      }
      return list;
    },

    // 地图初始化
    async mapInit(list) {
      var that = this;
      try {
        // 初始化地图
        this.initializeMap();
        // 加载行政区划数据
        const polygons = await this.loadDistrictPolygons();
        // 处理并显示行政区划
        this.processPolygons(polygons);
        // 创建热力图
        this.createHeatmap(list);
        setTimeout(function(){
          that.QHloading=false;
        }, 500);
      } catch (error) {
        console.error("地图初始化失败:", error);
      }
    },
    // 创建热力图层
    createHeatmap(pointsData) {
      //初始化网格热力图图并添加至map图层
      var grid = new TMap.visualization.Grid({
        sideLength: 500, // 设置网格边长
        heightRange: [1, 30000], // 高度变化区间
        showRange: [1, 100], // 聚合数据显示区间
        toggleAnimation: {
          animationType: "grow", //动画类型
          duration: 4000, //动画时长
        },
        colorList: ["#ea9c21", "#ea8e21", "#e6721c", "#e55f1d", "#cc2a18"], //颜色层级
      }).addTo(this.map);
      grid.setData(pointsData); //设置数据
      //数据聚合之后才能够真正获取值域范围
      grid.setShowRange(grid.getValueRange());
    },

    // 初始化地图基础配置
    initializeMap() {
      this.map = new TMap.Map("map", {
        center: new TMap.LatLng(23.126419, 113.234015),
        showLabel: false,
        zoom: 10.4, //设置地图缩放级别
        pitch: 50, //地图俯仰角度
        mapStyleId: "style2",
        showControl: false,
        baseMap: {
          type: "vector",
          features: ["base", "building3d"],
          styles: {
            sky: {
              color: "rgba(0, 0, 0, 0)", // 设置天空颜色为透明
            },
            background: {
              color: "rgba(0, 0, 0, 0)", // 设置天空颜色为透明
            },
            base: {
              color: "rgba(0, 0, 0, 0)", // 设置天空颜色为透明
            },
          },
        },
      });
    },

    // 加载行政区划数据
    async loadDistrictPolygons() {
      const district = new TMap.service.District({ polygon: 2 });
      var code = this.$FMTCode(this.$getCityFuqin("code"));
      if (this.$getCityFuqin("level") == 4) {
        var code = this.$FMTCode(this.$getUser("districtCode"));
      };
      const result = await district.search({ keyword: code });
      return new TMap.MultiPolygon({
        map: this.map,
        geometries: [],
      });
    },

    // 处理多边形数据
    processPolygons(polygons) {
      var code = this.$FMTCode(this.$getCityFuqin("code"));
      if (this.$getCityFuqin("level") == 4) {
        var code = this.$FMTCode(this.$getUser("districtCode"));
      };
      new TMap.service.District({ polygon: 2 }).search({ keyword: code }).then((result) => {
        result.result.forEach((level) => {
          level.forEach((place) => {
            // 生成多边形数据
            const geometries = place.polygon.map((polygon, index) => ({
              id: `${place.id}_${index}`,
              paths: polygon,
            }));

            // 更新多边形显示
            polygons.updateGeometries(geometries);

            // 计算并设置地图边界
            const bounds = this.calculateSafeBounds(place.polygon);
            this.map.fitBounds(bounds, { padding: 50 });

            // 创建遮罩层
            this.createMaskLayer(place.polygon);
          });
        });
      });
    },

    // 安全边界计算方法
    calculateSafeBounds(polygons) {
      // 初始化有效边界
      let swLat = 90,
        swLng = 180;
      let neLat = -90,
        neLng = -180;

      polygons.forEach((polygon) => {
        polygon.forEach((point) => {
          const lat = point.lat || point[0];
          const lng = point.lng || point[1];

          swLat = Math.min(swLat, lat);
          swLng = Math.min(swLng, lng);
          neLat = Math.max(neLat, lat);
          neLng = Math.max(neLng, lng);
        });
      });

      return new TMap.LatLngBounds(new TMap.LatLng(swLat, swLng), new TMap.LatLng(neLat, neLng));
    },

    // 创建区域镂空层
    createMaskLayer(targetPolygons) {
      if (this.maskLayer) {
        this.maskLayer.setMap(null);
      }

      // 转换所有多边形坐标并验证方向
      const processPolygon = (polygon) => {
        return polygon;
      };

      // 生成正确方向的外层路径（顺时针）
      var coverage = [new TMap.LatLng(-85, -180), new TMap.LatLng(-85, 180), new TMap.LatLng(85, 180), new TMap.LatLng(85, -180)];

      // 处理多个镂空区域
      const holes = targetPolygons
        .map((polygon) => {
          const validPolygon = processPolygon(polygon);
          if (validPolygon.length < 3) return null;
          return [...validPolygon].reverse(); // 逆时针
        })
        .filter((h) => h !== null);

      // 创建遮罩层
      try {
        this.maskLayer = new TMap.MultiPolygon({
          map: this.map,
          geometries: [
            {
              paths: [coverage, ...holes], // 合并所有路径
              styleId: "maskStyle",
            },
          ],
          styles: {
            maskStyle: new TMap.PolygonStyle({
              color: "rgba(0, 13, 57, 0.6)",
              showBorder: false,
              fillOpacity: 0.1,
              zIndex: 9999, // 设置层级高度，值越大越靠上
            }),
          },
          zIndex: 9999, // 设置层级高度，值越大越靠上
        });

        // 使用备用刷新方法
        setTimeout(() => {
          this.map.setCenter(this.map.getCenter());
          this.maskLayer.setZIndex(9999);
        }, 100);
      } catch (error) {
        console.error("遮罩层创建失败:", error);
      }
    },

    //生成覆盖可视区域的矩形
    createFullCoveragePolygon() {
      // 生成覆盖可视区域的矩形（考虑地图当前投影）
      const bounds = this.map.getBounds();
      return [bounds.getSouthWest(), new TMap.LatLng(bounds.getSouthWest().getLat(), bounds.getNorthEast().getLng()), bounds.getNorthEast(), new TMap.LatLng(bounds.getNorthEast().getLat(), bounds.getSouthWest().getLng())];
    },
  },

  //销毁地图
  beforeDestroy() {
    if (this.map) {
      this.map.destroy();
    }
  },
};
</script>
<style>
html{background: radial-gradient(circle, #0c96ff, #092654);}
.QHpostionDaohang .box {
  padding: 10px;
  font-size: 14px;
}
.QHpostionDaohang span {
  font-size: 20px;
  font-weight: 700;
  display: block;
}
</style>
